import { DataBean } from "../DataBean";

export class CreateTransportGuideItems extends DataBean {




    public async createTransportGuideItems(idTransportGuide: any, transportGuideDate: any, piecesNumber: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_createTransportGuideItems_Number_java.util.Date_Number", [idTransportGuide, transportGuideDate, piecesNumber]);
    }

}